import { render, staticRenderFns } from "./Explain.vue?vue&type=template&id=3c689e03&scoped=true"
import script from "./Explain.vue?vue&type=script&lang=js"
export * from "./Explain.vue?vue&type=script&lang=js"
import style0 from "./Explain.vue?vue&type=style&index=0&id=3c689e03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c689e03",
  null
  
)

export default component.exports